"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMCompilerUtils = void 0;
const inversify_1 = require("inversify");
const estraverse = __importStar(require("@javascript-obfuscator/estraverse"));
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const VMSharedTypes_1 = require("../../types/vm-transformers/VMSharedTypes");
const VMOpCode_1 = require("../../enums/vm-transformers/VMOpCode");
const VMConstantPool_1 = require("./VMConstantPool");
const VMVariableResolver_1 = require("./VMVariableResolver");
const NodeGuards_1 = require("../../node/NodeGuards");
const VMInstructionBuilder_1 = require("./VMInstructionBuilder");
const IScopeIdentifiersTraverser_1 = require("../../interfaces/node/IScopeIdentifiersTraverser");
const NodeFactory_1 = require("../../node/NodeFactory");
let VMCompilerUtils = class VMCompilerUtils {
    constructor(variableResolver, scopeIdentifiersTraverser) {
        this.variableResolver = variableResolver;
        this.scopeIdentifiersTraverser = scopeIdentifiersTraverser;
    }
    isEnvVariable(varName, context) {
        let currentContext = context;
        while (currentContext) {
            if (currentContext.envVars.has(varName)) {
                return true;
            }
            currentContext = currentContext.parentContext;
        }
        return false;
    }
    isDeclaredInParentScope(varName, context) {
        let currentContext = context;
        while (currentContext) {
            if (currentContext.envVars.has(varName)) {
                return true;
            }
            if (currentContext.localVariables.has(varName)) {
                return true;
            }
            const renamedPattern = `${varName}$$`;
            for (const localVar of currentContext.localVariables.keys()) {
                if (localVar.startsWith(renamedPattern)) {
                    return true;
                }
            }
            if (currentContext.parameters.has(varName) && !currentContext.parametersInTDZ.has(varName)) {
                return true;
            }
            for (const param of currentContext.parameters.keys()) {
                if (param.startsWith(renamedPattern) && !currentContext.parametersInTDZ.has(param)) {
                    return true;
                }
            }
            currentContext = currentContext.parentContext;
        }
        return false;
    }
    getActualLocalIndex(localVariableIndex, context) {
        return context.parameters.size + localVariableIndex;
    }
    getNextLocalIndex(context) {
        let maxIndex = -1;
        context.localVariables.forEach((idx) => {
            if (idx > maxIndex) {
                maxIndex = idx;
            }
        });
        return maxIndex + 1;
    }
    emitArgumentsSlice(startIndex, context) {
        const builder = this.createInstructionBuilder(context);
        builder.loadConst(startIndex);
        builder.arguments();
        builder.dup();
        builder.getProp('slice');
        builder.loadConst(1);
        builder.callMethod(1);
    }
    emitRestParameterHandling(restParamName, restParamPattern, regularParamCount, context) {
        var _a;
        const builder = this.createInstructionBuilder(context);
        this.emitArgumentsSlice(regularParamCount, context);
        if (restParamPattern !== null) {
            (_a = context.dispatch) === null || _a === void 0 ? void 0 : _a.destructuring(restParamPattern, false);
        }
        else {
            if (context.envVars.has(restParamName)) {
                builder.storeToEnvByName(restParamName);
            }
            else {
                const localIndex = context.localVariables.get(restParamName);
                const actualLocalIndex = this.getActualLocalIndex(localIndex, context);
                builder.storeLocal(actualLocalIndex);
            }
        }
    }
    createInstructionBuilder(context) {
        if (!context.builder) {
            context.builder = new VMInstructionBuilder_1.VMInstructionBuilder(context);
        }
        return context.builder;
    }
    patchJumpTargets(startIndex, endIndex, oldTarget, newTarget, context) {
        for (let i = startIndex; i < endIndex; i++) {
            const instr = context.instructions[i];
            if ((instr.op === VMOpCode_1.VMOpCode.JUMP || instr.op === VMOpCode_1.VMOpCode.BREAK || instr.op === VMOpCode_1.VMOpCode.CONTINUE) &&
                instr.target === oldTarget) {
                instr.target = newTarget;
            }
        }
    }
    patchLoopBreakStatements(breakTargetIndex, endTarget, context) {
        for (let i = breakTargetIndex; i < endTarget - 1; i++) {
            const instr = context.instructions[i];
            const isJumpOpcode = instr.op === VMOpCode_1.VMOpCode.JUMP ||
                instr.op === VMOpCode_1.VMOpCode.BREAK ||
                instr.op === VMOpCode_1.VMOpCode.CONTINUE;
            if (isJumpOpcode && instr.target === breakTargetIndex) {
                instr.target = endTarget;
            }
        }
    }
    patchLabeledBreakStatements(breakTargetIndex, endTarget, context) {
        for (let i = breakTargetIndex; i < endTarget; i++) {
            const instr = context.instructions[i];
            const isBreakOpcode = instr.op === VMOpCode_1.VMOpCode.JUMP || instr.op === VMOpCode_1.VMOpCode.BREAK;
            if (isBreakOpcode && instr.target === breakTargetIndex) {
                instr.target = endTarget;
            }
        }
    }
    createTempLocal(tempVarName, context) {
        const localIndex = context.localVariables.size;
        context.localVariables.set(tempVarName, localIndex);
        const actualIndex = this.getActualLocalIndex(localIndex, context);
        return { localIndex, actualIndex };
    }
    emitLoadVariable(varName, context) {
        const builder = this.createInstructionBuilder(context);
        const resolution = this.variableResolver.resolve(varName, context);
        switch (resolution.location) {
            case VMSharedTypes_1.VariableLocation.Environment:
                builder.loadFromEnv(resolution.index);
                break;
            case VMSharedTypes_1.VariableLocation.Parameter:
                builder.loadArg(resolution.index);
                break;
            case VMSharedTypes_1.VariableLocation.Local: {
                const actualIndex = this.getActualLocalIndex(resolution.index, context);
                builder.loadLocal(actualIndex);
                break;
            }
            case VMSharedTypes_1.VariableLocation.Global:
                builder.loadGlobal(resolution.index);
                break;
        }
    }
    emitStoreVariable(varName, context) {
        const builder = this.createInstructionBuilder(context);
        const resolution = this.variableResolver.resolve(varName, context, true);
        switch (resolution.location) {
            case VMSharedTypes_1.VariableLocation.Environment:
                builder.storeToEnv(resolution.index);
                break;
            case VMSharedTypes_1.VariableLocation.Parameter:
                builder.storeArg(resolution.index);
                break;
            case VMSharedTypes_1.VariableLocation.Local: {
                const actualIndex = this.getActualLocalIndex(resolution.index, context);
                if (context.constLocalVariables.has(actualIndex)) {
                    builder.pop();
                    builder.throwError('TypeError', 'Assignment to constant variable.');
                    return;
                }
                builder.storeLocal(actualIndex);
                break;
            }
            case VMSharedTypes_1.VariableLocation.Global:
                builder.storeGlobal(resolution.index);
                builder.pop();
                break;
        }
    }
    createContext(parentContext, isArrowFunction = false, topLevelVariables) {
        const context = {
            constantPool: new VMConstantPool_1.VMConstantPool(),
            instructions: [],
            localVariables: new Map(),
            parameters: new Map(),
            parametersInTDZ: new Set(),
            localVariablesInTDZ: new Set(),
            constLocalVariables: new Set(),
            breakTargets: [],
            breakEnvDepths: [],
            continueTargets: [],
            continueEnvDepths: [],
            labelTargets: new Map(),
            labelContinueTargets: new Map(),
            currentLabel: null,
            activeFinallyBlocks: [],
            nextBytecodeId: 0,
            parentContext,
            capturedVars: new Set(),
            envVars: new Set(),
            nestedFunctions: new Map(),
            functionRefIndices: new Set(),
            isArrowFunction,
            capturedThis: false,
            capturedArguments: false,
            blockScopeDepth: 0,
            variableScopes: new Map(),
            activeBlockScopes: new Set(),
            envDepth: 0,
            isFunctionBody: false,
            hoistedFunctionDeclarations: new Set(),
            maxLocals: 0,
            dispatchFactory: parentContext === null || parentContext === void 0 ? void 0 : parentContext.dispatchFactory,
            topLevelVariables,
            perIterationLoopVars: parentContext === null || parentContext === void 0 ? void 0 : parentContext.perIterationLoopVars,
            declaredVariables: new Set(),
            classExpressionNameAliases: parentContext === null || parentContext === void 0 ? void 0 : parentContext.classExpressionNameAliases
        };
        if (context.dispatchFactory) {
            context.dispatch = context.dispatchFactory(context);
        }
        return context;
    }
    traverseStatements(statements, visitor) {
        for (const stmt of statements) {
            estraverse.traverse(stmt, {
                enter: (node) => {
                    if (NodeGuards_1.NodeGuards.isStatementOrDeclarationNode(node)) {
                        visitor(node);
                    }
                    if (NodeGuards_1.NodeGuards.isFunctionNode(node)) {
                        return estraverse.VisitorOption.Skip;
                    }
                }
            });
        }
    }
    emitConditionalJump(opcode, context) {
        const builder = this.createInstructionBuilder(context);
        const jumpIndex = builder.currentInstructionIndex();
        builder.emitRaw({ op: opcode, target: 0 });
        return jumpIndex;
    }
    patchJump(jumpIndex, context, target) {
        const actualTarget = target !== null && target !== void 0 ? target : context.instructions.length;
        context.instructions[jumpIndex].target = actualTarget;
    }
    adjustJumpTargetsAfterInsertion(insertIndex, insertCount, context) {
        for (const instr of context.instructions) {
            if ('target' in instr && instr.target !== undefined) {
                const jumpInstr = instr;
                if (jumpInstr.target >= insertIndex) {
                    jumpInstr.target += insertCount;
                }
            }
            if (instr.op === VMOpCode_1.VMOpCode.TRY_START) {
                const tryInstr = instr;
                if (tryInstr.catchIndex !== undefined && tryInstr.catchIndex >= insertIndex) {
                    tryInstr.catchIndex += insertCount;
                }
                if (tryInstr.finallyIndex !== undefined && tryInstr.finallyIndex >= insertIndex) {
                    tryInstr.finallyIndex += insertCount;
                }
                if (tryInstr.endIndex !== undefined && tryInstr.endIndex >= insertIndex) {
                    tryInstr.endIndex += insertCount;
                }
            }
        }
    }
    extractIdentifiersFromPattern(node) {
        const identifiers = [];
        const wrappedProgram = NodeFactory_1.NodeFactory.programNode([
            NodeFactory_1.NodeFactory.variableDeclarationNode([NodeFactory_1.NodeFactory.variableDeclaratorNode(node, null)])
        ]);
        this.scopeIdentifiersTraverser.traverseScopeIdentifiers(wrappedProgram, wrappedProgram, (data) => {
            identifiers.push(data.variable.name);
        });
        return identifiers;
    }
    traverseBlocksSkipScopes(node, visitor) {
        if (NodeGuards_1.NodeGuards.isFunctionOrClassNode(node)) {
            return;
        }
        visitor(node);
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(node)) {
            for (const statement of node.body) {
                this.traverseBlocksSkipScopes(statement, visitor);
            }
        }
        else if (NodeGuards_1.NodeGuards.isIfStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.consequent, visitor);
            if (node.alternate) {
                this.traverseBlocksSkipScopes(node.alternate, visitor);
            }
        }
        else if (NodeGuards_1.NodeGuards.isWhileStatementNode(node) || NodeGuards_1.NodeGuards.isDoWhileStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.body, visitor);
        }
        else if (NodeGuards_1.NodeGuards.isForStatementNode(node)) {
            if (node.init) {
                this.traverseBlocksSkipScopes(node.init, visitor);
            }
            this.traverseBlocksSkipScopes(node.body, visitor);
        }
        else if (NodeGuards_1.NodeGuards.isForOfStatementNode(node) || NodeGuards_1.NodeGuards.isForInStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.left, visitor);
            this.traverseBlocksSkipScopes(node.body, visitor);
        }
        else if (NodeGuards_1.NodeGuards.isSwitchStatementNode(node)) {
            for (const caseClause of node.cases) {
                for (const statement of caseClause.consequent) {
                    this.traverseBlocksSkipScopes(statement, visitor);
                }
            }
        }
        else if (NodeGuards_1.NodeGuards.isTryStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.block, visitor);
            if (node.handler) {
                this.traverseBlocksSkipScopes(node.handler.body, visitor);
            }
            if (node.finalizer) {
                this.traverseBlocksSkipScopes(node.finalizer, visitor);
            }
        }
        else if (NodeGuards_1.NodeGuards.isLabeledStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.body, visitor);
        }
        else if (NodeGuards_1.NodeGuards.isWithStatementNode(node)) {
            this.traverseBlocksSkipScopes(node.body, visitor);
        }
    }
    containsFunction(node) {
        let hasFunction = false;
        estraverse.traverse(node, {
            enter: (currentNode) => {
                var _a;
                if (NodeGuards_1.NodeGuards.isFunctionNode(currentNode)) {
                    hasFunction = true;
                    return estraverse.VisitorOption.Break;
                }
                if (NodeGuards_1.NodeGuards.isClassNode(currentNode)) {
                    if ((_a = currentNode.body) === null || _a === void 0 ? void 0 : _a.body) {
                        for (const element of currentNode.body.body) {
                            if (NodeGuards_1.NodeGuards.isPropertyDefinitionNode(element) && element.value !== null) {
                                hasFunction = true;
                                return estraverse.VisitorOption.Break;
                            }
                            if (NodeGuards_1.NodeGuards.isStaticBlockNode(element)) {
                                hasFunction = true;
                                return estraverse.VisitorOption.Break;
                            }
                        }
                    }
                }
            }
        });
        return hasFunction;
    }
    checkVariableShadowsOuter(varName, context, hasBlockScopedDecl) {
        if (!hasBlockScopedDecl) {
            return false;
        }
        const baseName = varName.split('$$')[0];
        const hasMatchingBaseName = Array.from(context.localVariables.keys()).some((key) => {
            const keyBase = key.split('$$')[0];
            return keyBase === baseName;
        });
        const shadowsParameter = context.parameters.has(varName);
        const shadowsOuterVariable = (!!context.parentContext && this.isDeclaredInParentScope(varName, context.parentContext)) ||
            shadowsParameter ||
            context.envVars.has(varName) ||
            context.localVariables.has(varName) ||
            hasMatchingBaseName;
        return shadowsOuterVariable;
    }
    collectReferencedIdentifiers(node) {
        const references = new Set();
        estraverse.traverse(node.body, {
            enter: (currentNode, parent) => {
                if (NodeGuards_1.NodeGuards.isFunctionNode(currentNode) && currentNode !== node) {
                    return estraverse.VisitorOption.Skip;
                }
                if (!NodeGuards_1.NodeGuards.isIdentifierNode(currentNode)) {
                    return;
                }
                if (parent) {
                    if (NodeGuards_1.NodeGuards.isVariableDeclaratorNode(parent) && parent.id === currentNode) {
                        return;
                    }
                    if (NodeGuards_1.NodeGuards.isFunctionNode(parent) && parent.params.includes(currentNode)) {
                        return;
                    }
                    if (NodeGuards_1.NodeGuards.isPropertyNode(parent) && parent.key === currentNode && !parent.computed) {
                        return;
                    }
                    if (NodeGuards_1.NodeGuards.isMemberExpressionNode(parent) && parent.property === currentNode && !parent.computed) {
                        return;
                    }
                    if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(parent) && parent.id === currentNode) {
                        return;
                    }
                    if (parent.type === 'CatchClause' && parent.param === currentNode) {
                        return;
                    }
                }
                references.add(currentNode.name);
            }
        });
        return references;
    }
};
exports.VMCompilerUtils = VMCompilerUtils;
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableResolver),
    __metadata("design:type", typeof (_c = typeof VMVariableResolver_1.VMVariableResolver !== "undefined" && VMVariableResolver_1.VMVariableResolver) === "function" ? _c : Object)
], VMCompilerUtils.prototype, "variableResolver", void 0);
__decorate([
    (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IScopeIdentifiersTraverser),
    __metadata("design:type", typeof (_d = typeof IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser !== "undefined" && IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser) === "function" ? _d : Object)
], VMCompilerUtils.prototype, "scopeIdentifiersTraverser", void 0);
exports.VMCompilerUtils = VMCompilerUtils = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableResolver)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IScopeIdentifiersTraverser)),
    __metadata("design:paramtypes", [typeof (_a = typeof VMVariableResolver_1.VMVariableResolver !== "undefined" && VMVariableResolver_1.VMVariableResolver) === "function" ? _a : Object, typeof (_b = typeof IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser !== "undefined" && IScopeIdentifiersTraverser_1.IScopeIdentifiersTraverser) === "function" ? _b : Object])
], VMCompilerUtils);
